export const dummyRequests = [
  {
    itemName: "Toilet Paper",
    createdTimestamp: "3/30/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Canned Soup",
    createdTimestamp: "3/27/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/28/2020"
  },
  {
    itemName: "Pack of Water bottles",
    createdTimestamp: "3/23/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Toilet Paper",
    createdTimestamp: "3/21/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/23/2020"
  },
    {
    itemName: "Toilet Paper",
    createdTimestamp: "3/30/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Canned Soup",
    createdTimestamp: "3/27/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/28/2020"
  },
  {
    itemName: "Pack of Water bottles",
    createdTimestamp: "3/23/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Toilet Paper",
    createdTimestamp: "3/21/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/23/2020"
  },
    {
    itemName: "Toilet Paper",
    createdTimestamp: "3/30/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Canned Soup",
    createdTimestamp: "3/27/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/28/2020"
  },
  {
    itemName: "Pack of Water bottles",
    createdTimestamp: "3/23/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Toilet Paper",
    createdTimestamp: "3/21/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/23/2020"
  },
    {
    itemName: "Toilet Paper",
    createdTimestamp: "3/30/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Canned Soup",
    createdTimestamp: "3/27/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/28/2020"
  },
  {
    itemName: "Pack of Water bottles",
    createdTimestamp: "3/23/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Toilet Paper",
    createdTimestamp: "3/21/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/23/2020"
  },
    {
    itemName: "Toilet Paper",
    createdTimestamp: "3/30/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Canned Soup",
    createdTimestamp: "3/27/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/28/2020"
  },
  {
    itemName: "Pack of Water bottles",
    createdTimestamp: "3/23/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Toilet Paper",
    createdTimestamp: "3/21/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/23/2020"
  },
    {
    itemName: "Toilet Paper",
    createdTimestamp: "3/30/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Canned Soup",
    createdTimestamp: "3/27/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/28/2020"
  },
  {
    itemName: "Pack of Water bottles",
    createdTimestamp: "3/23/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Toilet Paper",
    createdTimestamp: "3/21/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/23/2020"
  },
    {
    itemName: "Toilet Paper",
    createdTimestamp: "3/30/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Canned Soup",
    createdTimestamp: "3/27/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/28/2020"
  },
  {
    itemName: "Pack of Water bottles",
    createdTimestamp: "3/23/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Toilet Paper",
    createdTimestamp: "3/21/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/23/2020"
  },
    {
    itemName: "Toilet Paper",
    createdTimestamp: "3/30/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Canned Soup",
    createdTimestamp: "3/27/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/28/2020"
  },
  {
    itemName: "Pack of Water bottles",
    createdTimestamp: "3/23/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Toilet Paper",
    createdTimestamp: "3/21/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/23/2020"
  },
    {
    itemName: "Toilet Paper",
    createdTimestamp: "3/30/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Canned Soup",
    createdTimestamp: "3/27/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/28/2020"
  },
  {
    itemName: "Pack of Water bottles",
    createdTimestamp: "3/23/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Toilet Paper",
    createdTimestamp: "3/21/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/23/2020"
  },
    {
    itemName: "Toilet Paper",
    createdTimestamp: "3/30/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Canned Soup",
    createdTimestamp: "3/27/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/28/2020"
  },
  {
    itemName: "Pack of Water bottles",
    createdTimestamp: "3/23/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Toilet Paper",
    createdTimestamp: "3/21/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/23/2020"
  },
    {
    itemName: "Toilet Paper",
    createdTimestamp: "3/30/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Canned Soup",
    createdTimestamp: "3/27/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/28/2020"
  },
  {
    itemName: "Pack of Water bottles",
    createdTimestamp: "3/23/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Toilet Paper",
    createdTimestamp: "3/21/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/23/2020"
  },
    {
    itemName: "Toilet Paper",
    createdTimestamp: "3/30/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Canned Soup",
    createdTimestamp: "3/27/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/28/2020"
  },
  {
    itemName: "Pack of Water bottles",
    createdTimestamp: "3/23/2020",
    fulfilled: false,
    fulfilledTimestamp: ""
  },
  {
    itemName: "Toilet Paper",
    createdTimestamp: "3/21/2020",
    fulfilled: true,
    fulfilledTimestamp: "3/23/2020"
  },
];

export const dummyTips = [
  {
    tip: "Toilet Paper at Costco!",
    name: "Costco",
    address: "41 Meadowbrook Ave. Pottstown, PA 19464"
  },
    {
    tip: "All you can eat Spam!",
    name: "Stater Bros",
    address: "7583 Piper Lane Bensalem, PA 19020"
  },
    {
    tip: "NO MORE TOILET PAPER AT WALMART! :(",
    name: "Walmart",
    address: "41 8265 Ryan Road Canyon Country, CA 91387"
  }
]